export default __webpack_public_path__ + "media/plus/test-plus-dedicated-support-587a8f7b.png";